import positionTransactionsFactory from '../transactions-global/position-transactions-factory';

export default positionTransactionsFactory({
  assetCategory: 'genericAssets',
});
